import OauthLanding from './OauthLanding';

export default OauthLanding;
